import { render, staticRenderFns } from "./CabinetAlertsTable.vue?vue&type=template&id=71c37d0a"
import script from "./CabinetAlertsTable.vue?vue&type=script&lang=ts"
export * from "./CabinetAlertsTable.vue?vue&type=script&lang=ts"
import style0 from "./CabinetAlertsTable.vue?vue&type=style&index=0&id=71c37d0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports